<div *ngIf="dataLoaded && !errorMessage && referralTable && referralTable.data.length > 0">
  <div class="referral-rewards-summary row">
    <div class="col">
      <strong>Total Referral Rewards </strong><strong>₹{{ totalReferralRewards | number }}</strong>
    </div>
    <div class="col">
      <strong>Total Pending Rewards </strong><strong>₹{{ totalPendingRewards | number }}</strong>
    </div>
  </div>
  <div class="referral-rewards-summary row">
    <div class="col">
      <strong>Referrer Rewards </strong><strong>₹{{ referrerRewards | number }}</strong>
    </div>
    <div class="col">
      <strong>Pending Referrer Rewards </strong><strong>₹{{ pendingReferrerAmount | number }}</strong>
    </div>
  </div>
  <div class="referral-rewards-summary row">
    <div class="col">
      <strong>Referred Rewards </strong><strong>₹{{ referredRewards | number }}</strong>
    </div>
    <div class="col">
      <strong>Pending Referred Rewards </strong><strong>₹{{ pendingReferredAmount | number }}</strong>
    </div>
  </div>
</div>
<div class="height-15" *ngIf="dataLoaded && !errorMessage && referralTable && referralTable.data.length > 0"></div>

<app-table-scrollable
  *ngIf="dataLoaded && referralTable"
  (headerToggled)="changeInHeader($event)"
  (paginationChange)="onPaginationChange($event)"
  [table]="referralTable"
  [filterNotRequired]="true"
></app-table-scrollable>

<div class="row" *ngIf="!dataLoaded">
  <div class="col-md-12">
    <content-loader>
      <svg:rect x="0" y="0" rx="3" ry="3" width="1000" height="10" />
      <svg:rect x="0" y="20" rx="3" ry="3" width="1000" height="10" />
      <svg:rect x="0" y="40" rx="3" ry="3" width="1000" height="10" />
      <svg:rect x="0" y="60" rx="3" ry="3" width="1000" height="10" />
      <svg:rect x="0" y="80" rx="3" ry="3" width="1000" height="10" />
      <svg:rect x="0" y="100" rx="3" ry="3" width="1000" height="10" />
    </content-loader>
  </div>
</div>
